import { AutocompleteMultiSelect } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingFormValue, TargetingLanguage } from '../../model';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { TargetingSection } from './TargetingSection';
import { TargetingConsumer } from '../../config';
import {
  madBuyLanguageKey,
  selectMadBuyLanguages,
} from '../../../campaigns/campaigns/madBuyLanguageModel';

export function LanguagesTargetingSection({
  languages,
  consumer,
  updateField,
  value,
}: {
  languages: TargetingLanguage[];
  consumer: TargetingConsumer;
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  const isMadBuy = consumer === TargetingConsumer.LineItem;
  const languageKey = isMadBuy ? madBuyLanguageKey : (language: TargetingLanguage) => language.id;
  return (
    <TargetingSection title={dashboardT('targeting.userLanguages')}>
      <AutocompleteMultiSelect
        label={dashboardT('targeting.userLanguagesLabel')}
        placeholder={dashboardT('targeting.chooseLanguages')}
        emptyMessage={dashboardT('targeting.noLanguages')}
        options={languages.map((language) => ({ id: languageKey(language), label: language.name }))}
        value={value.userLanguages.map(languageKey)}
        maxResults={languages.length}
        onValueChange={(ids) => {
          const selectedIds = new Set(ids);
          updateField(
            'userLanguages',
            isMadBuy
              ? selectMadBuyLanguages(languages, value.userLanguages, ids)
              : languages.filter((language) => selectedIds.has(language.id)),
          );
        }}
      />
    </TargetingSection>
  );
}
